import { render, staticRenderFns } from "./detailperson1.vue?vue&type=template&id=53eb9138&scoped=true"
import script from "./detailperson1.vue?vue&type=script&lang=js"
export * from "./detailperson1.vue?vue&type=script&lang=js"
import style0 from "./detailperson1.vue?vue&type=style&index=0&id=53eb9138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb9138",
  null
  
)

export default component.exports